"use client";

import { useState } from "react";
import { ContactForm } from "@/components/contact-form";
import type { ContactFormT } from "@/lib/translations";

const CALENDLY_URL =
  "https://calendly.com/gustas-fluxrivet/30min?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=000000&background_color=ffffff";

export function ContactRightPanel({ t }: { t?: ContactFormT }) {
  const [tab, setTab] = useState<"book" | "form">("book");
  const tabBook = t?.tabBook ?? "Free Scope Call";
  const tabForm = t?.tabForm ?? "Send a Message";

  return (
    <div className="flex flex-col">
      <div className="flex border-b border-black">
        <button
          onClick={() => setTab("book")}
          className={`flex-1 px-6 py-4 font-label-caps text-[11px] uppercase tracking-widest font-bold border-r border-black transition-colors duration-150 ${
            tab === "book"
              ? "bg-black text-white"
              : "bg-white text-primary hover:bg-surface-container-low"
          }`}
        >
          {tabBook}
        </button>
        <button
          onClick={() => setTab("form")}
          className={`flex-1 px-6 py-4 font-label-caps text-[11px] uppercase tracking-widest font-bold transition-colors duration-150 ${
            tab === "form"
              ? "bg-black text-white"
              : "bg-white text-primary hover:bg-surface-container-low"
          }`}
        >
          {tabForm}
        </button>
      </div>

      <div style={{ display: tab === "book" ? "block" : "none" }} className="flex-1">
        <div
          className="calendly-inline-widget w-full"
          data-url={CALENDLY_URL}
          style={{ minWidth: "320px", height: "calc(100vh - 350px)", minHeight: "580px" }}
        />
      </div>

      <div style={{ display: tab === "form" ? "block" : "none" }}>
        <ContactForm t={t} />
      </div>
    </div>
  );
}
